const focusOnPopup = ({ id }) => {
  const modal = document.querySelector(`#${id}`);
  if (!modal) return;

  const focusableElementsSelector =
    'a[href]:not(.btn-close), button:not(.btn-close), textarea:not(.btn-close), input[type="text"]:not(.btn-close), input[type="radio"]:not(.btn-close), input[type="checkbox"]:not(.btn-close), select:not(.btn-close)';

  const focusableContent = modal.querySelectorAll(focusableElementsSelector);
  if (!focusableContent.length) return;

  const firstFocusableElement = focusableContent[0];
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  const trapFocus = (e) => {
    const isTabPressed = e.key === "Tab" || e.keyCode === 9;
    if (!isTabPressed) return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  };

  // Attach the event only once
  modal.addEventListener("keydown", trapFocus);

  // Focus the first element
  firstFocusableElement.focus();

  // Optional: return a cleanup function
  return () => {
    modal.removeEventListener("keydown", trapFocus);
  };
};

export default focusOnPopup;
